import type { ComponentType } from 'react'

import { AppId, RichAppIconProps } from '@inno-tools/container-bridge'

export interface BaseWindowState {
  id: string
  title: string
  position: {
    x: number
    y: number
  }
  size: {
    width: number
    height: number
  }

  canMaximize?: boolean
  canMinimize?: boolean
  canSnap?: boolean

  isMinimized: boolean
  isMaximized: boolean
  isVisible: boolean
  icon?: string
  snapArea: SnapArea | null
  onCloseCallback?: () => void
}

export type IframeWindowContent = BaseWindowState & {
  url: string
  currentHistoryIndex: number
  history: string[]
  localComponent?: never
}

export type LocalWindowContent = BaseWindowState & {
  url?: never
  currentHistoryIndex?: never
  history?: never
  localComponent: () => JSX.Element
}

export type WindowState = IframeWindowContent | LocalWindowContent

/** @public Used in the exported window manager return type. */
export interface AppInstanceBase {
  name: string
  label: string
  richAppIcon?: ComponentType<RichAppIconProps>
  icon?: string
  color?: string
  category?: string
  isPinned?: boolean
}

export type IframeAppInstance = AppInstanceBase & {
  id: AppId
  url: string
  localComponent?: never
}

type ComponentAppInstance = AppInstanceBase & {
  id: string
  url?: never
  localComponent: () => JSX.Element
}

export type AppInstance = IframeAppInstance | ComponentAppInstance

// Window snapping zones (excluding fullscreen which maps to maximize)
export enum SnapArea {
  LEFT_HALF = 'leftHalf',
  TOP_LEFT = 'topLeft',
  BOTTOM_LEFT = 'bottomLeft',
  RIGHT_HALF = 'rightHalf',
  TOP_RIGHT = 'topRight',
  BOTTOM_RIGHT = 'bottomRight',
  FULLSCREEN = 'fullscreen'
}

export interface CompletedTourTypes {
  'user-menu-tour': boolean
  'full-page-onboarding': boolean
}

export interface WallpaperDataType {
  id: string
  image: string
  thumbnail?: string
  name?: string
  localizedNames?: Record<string, string>
  /** ID of a catalog definition, rather than a hard-coded renderer preset. */
  animation?: string
}
